import { useDispatch, useSelector } from "react-redux";
import { GetTotal, clearCart, showCart } from "../ReduxToolKit/cartSlice";
import CartItem from "../components/CartItem"
import EmptyCart from "../components/EmptyCart"
import { useEffect } from "react";
const Cart = () => {
    const dispatch = useDispatch();
    const { cartTotalAmount, cartTotalQty, cart } = useSelector(state => state.Cart);
    useEffect(() => {
        dispatch(GetTotal()) 
    }, [cart,dispatch]) 
    return (
        <>
            <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                    <p className="text-black cursor-pointer"><i onClick={() => dispatch(showCart(false))} className="text-black fas fa-arrow-left"></i> your cart</p>
                    <button className="bg-black text-white px-1 py-[2px] rounded-md">({cartTotalQty} items)</button>
                </div>
                <button onClick={() => dispatch(clearCart())} className="bg-black text-white px-[5px] rounded-sm text-center">Clear <i className="fas fa-times"></i></button>
            </div>

            <div className=" scroll_bar_hidden mt-5 gap-4 flex flex-col max-h-[580px] overflow-y-auto">
                {!(cart?.length === 0) ? (
                    cart?.map((item) => {
                        return <CartItem data={item} key={item?.id} />
                    })
                ) : (
                    <EmptyCart />
                )}
            </div>
            <div className="cartSideBarFooter absolute bottom-0 w-full px-5 bg-white">
                <div className="flex justify-between items-center pr-5">
                    <h4 className="uppercase text-black font-semibold text-[14px]">subtotal</h4>
                    <button className="bg-black text-white px-1 py-[2px] text-[12pxv] rounded-md">${cartTotalAmount}</button>
                </div>
                <p className="capitalize text-center text-black text-[12px]">Taxes and shipping will calculate at shipping</p>
                <button className="bg-black text-white px-1 py-2 my-2 rounded-sm w-full">Check Out</button>
            </div>
        </>
    )
}
export default Cart;